import { render, staticRenderFns } from "./KnowledgeContentTags.vue?vue&type=template&id=6c7b393c&"
import script from "./KnowledgeContentTags.vue?vue&type=script&lang=js&"
export * from "./KnowledgeContentTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports